import { combineReducers, configureStore } from "@reduxjs/toolkit";
import appSliceReducer from "./slices/appSlice";
import userSliceReducer, { userLoggedOut } from "./slices/userSlice";
import assetSliceReducer from "./slices/assetSlice";
import organizationSliceReducer from "./slices/organizationSlice";
import displayedSurveySliceReducer from "./slices/displayedSurveySlice";
import compareSliceReducer from "./slices/compareSlice";
import imagesModuleSliceReducer from "./slices/imagesModuleSlice";
import cesiumSliceReducer from "./slices/cesiumSlice";
import cesiumToolBarSliceReducer from "./slices/cesiumToolBarSlice";
import leftViewSliceReducer from "./slices/leftViewSlice";
import bottomViewSliceReducer from "./slices/bottomViewSlice";
import modalSliceReducer from "./slices/ModalSlice";
import infoTabSliceReducer from "./slices/InfoTabSlice";
import surveyTabSliceReducer from "./slices/SurveysTabSlice";
import annotationsManagerSliceReducer from "./slices/annotationsManagerSlice";
import  entitiesControllerSliceReducer from "./slices/entitiesControllerSlice";
import mainViewSliceReducer from "./slices/mainViewSlice";
import componentAllocatorSliceReducer from "./slices/componentAllocatorSlice";
import reportsSliceReducer from "./slices/reportsSlice";
import chatSliceReducer from "./slices/chatSlice"; 
import rightClickMenuReducer from "./slices/rightClickMenuSlice";
import taskSliceReducer from "./slices/tasksSlice";
import logsSliceReducer from "./slices/logsSlice";
import notificationsSliceReducer from "./slices/notificationsSlice";
import historySliceReducer from "./slices/historySlice";

const appReducer = combineReducers({
    app: appSliceReducer,
    user: userSliceReducer,
    displayedSurvey: displayedSurveySliceReducer,
    compare: compareSliceReducer,
    organization: organizationSliceReducer,
    asset: assetSliceReducer,
    imagesModule: imagesModuleSliceReducer,
    cesium: cesiumSliceReducer,
    cesiumToolBar: cesiumToolBarSliceReducer,
    leftView: leftViewSliceReducer,
    bottomView: bottomViewSliceReducer,
    modal: modalSliceReducer,
    infoTab: infoTabSliceReducer,
    surveysTab: surveyTabSliceReducer,
    annotationsManager: annotationsManagerSliceReducer,
    entitiesController: entitiesControllerSliceReducer,
    mainView: mainViewSliceReducer,
    componentAllocator: componentAllocatorSliceReducer,
    reports: reportsSliceReducer,
    chat: chatSliceReducer,
    rightClickMenu: rightClickMenuReducer,
    tasks: taskSliceReducer,
    logs: logsSliceReducer,
    notifications: notificationsSliceReducer,
    history: historySliceReducer,
  });

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === userLoggedOut.type) {
    // Reset all state
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
